import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ToggleButton from 'react-toggle-button';
import ReactJsAlert from 'reactjs-alert';
import { getToken } from '../../../../features/token/tokenSaver';
import { checkEmptyObj } from '../../../../services/checkEmptyObj';
import { createScreenHost } from '../../../../services/createScreenHost';
import '../../AdminDashboardAdvertisers/CreateAdvertiser/CreateAdvertiser.css';

const initialHost = {
    fname: '',
    lname: '',
    email: '',
    phoneNumber: '',
    password: '',
    city: '',
    active: true,
    businessName: '',
    businessAddress: '',
    businessCity: '',
    businessState: '',
    businessZipCode: '',
    zellePhoneNumber: '',
    zelleEmail: '',
    revenueSharePercent: '10',
};

export default function CreateScreenHost() {
    const [hostData, setHostData] = useState(initialHost);
    const [error, setError] = useState(false);
    const [errorCode, setErrorCode] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const token = useSelector(getToken);
    const navigate = useNavigate();

    function onChange(propertyName, newValue) {
        setHostData({ ...hostData, [propertyName]: newValue });
    }

    function onSubmit(event) {
        event.preventDefault();
        setError(false);

        const required = {
            fname: hostData.fname,
            lname: hostData.lname,
            email: hostData.email,
            phoneNumber: hostData.phoneNumber,
            password: hostData.password,
            businessName: hostData.businessName,
            businessAddress: hostData.businessAddress,
            businessCity: hostData.businessCity,
            businessState: hostData.businessState,
            businessZipCode: hostData.businessZipCode
        };

        if (checkEmptyObj(required)) {
            setError(true);
            setErrorCode('Please fill in all required fields.');
            return;
        }

        if (hostData.password.length < 8) {
            setError(true);
            setErrorCode('Password must be at least 8 characters.');
            return;
        }

        setSubmitting(true);
        createScreenHost(
            {
                ...hostData,
                active: hostData.active ? 1 : 0,
                zellePhoneNumber: hostData.zellePhoneNumber || undefined,
                zelleEmail: hostData.zelleEmail || undefined,
                city: hostData.city || undefined,
                revenueSharePercent: Number(hostData.revenueSharePercent) || 10,
            },
            token
        )
            .then(() => {
                navigate('/adminDashboard/users/hosts');
            })
            .catch((e) => {
                setError(true);
                setErrorCode(
                    e.response?.data?.error || e.message || 'Failed to create screen host.'
                );
                setSubmitting(false);
            });
    }

    return (
        <div>
            <ReactJsAlert
                status={error}
                type="error"
                title="There was an error submitting your form"
                quotes={true}
                quote={errorCode}
                Close={() => setError(false)}
                color="#1E1E1E"
            />
            <span className="registeredScreensTitle advertiserListTitle">Register Screen Host</span>
            <form onSubmit={onSubmit} className="advertiserRegisterContainer">
                <div className="advertiserRegisterItemfull">
                    <span className="advertiserRegisterItemTitle">Active</span>
                    <ToggleButton
                        value={hostData.active}
                        onToggle={(value) => onChange('active', !value)}
                    />
                </div>

                <div className="advertiserRegisterItemhalfright">
                    <span className="advertiserRegisterItemTitle">First Name</span>
                    <input
                        required
                        maxLength={50}
                        onChange={(e) => onChange('fname', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="First Name"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">Last Name</span>
                    <input
                        required
                        maxLength={50}
                        onChange={(e) => onChange('lname', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Last Name"
                        type="text"
                    />
                </div>

                <div className="advertiserRegisterItemhalfright">
                    <span className="advertiserRegisterItemTitle">Email</span>
                    <input
                        required
                        maxLength={100}
                        onChange={(e) => onChange('email', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Email"
                        type="email"
                    />
                </div>
                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">Phone</span>
                    <input
                        required
                        onChange={(e) => onChange('phoneNumber', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="10-digit mobile"
                        type="tel"
                    />
                </div>

                <div className="advertiserRegisterItemhalfright">
                    <span className="advertiserRegisterItemTitle">Password (initial)</span>
                    <input
                        required
                        minLength={8}
                        onChange={(e) => onChange('password', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Min 8 characters"
                        type="password"
                    />
                </div>
                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">City (optional)</span>
                    <input
                        maxLength={50}
                        onChange={(e) => onChange('city', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="City"
                        type="text"
                    />
                </div>

                <div className="advertiserRegisterItemfull">
                    <span className="advertiserRegisterItemTitle">Business Name</span>
                    <input
                        required
                        maxLength={50}
                        onChange={(e) => onChange('businessName', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Business Name"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemfull">
                    <span className="advertiserRegisterItemTitle">Business Address</span>
                    <input
                        required
                        maxLength={50}
                        onChange={(e) => onChange('businessAddress', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Street address"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemhalfright">
                    <span className="advertiserRegisterItemTitle">Business City</span>
                    <input
                        required
                        maxLength={50}
                        onChange={(e) => onChange('businessCity', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="City"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">Business State</span>
                    <input
                        required
                        maxLength={10}
                        onChange={(e) => onChange('businessState', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="CA"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemhalfright">
                    <span className="advertiserRegisterItemTitle">Business Zip</span>
                    <input
                        required
                        maxLength={30}
                        onChange={(e) => onChange('businessZipCode', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Zip"
                        type="text"
                    />
                </div>
                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">Zelle Phone (optional)</span>
                    <input
                        onChange={(e) => onChange('zellePhoneNumber', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Zelle phone"
                        type="tel"
                    />
                </div>
                <div className="advertiserRegisterItemfull">
                    <span className="advertiserRegisterItemTitle">Zelle Email (optional)</span>
                    <input
                        onChange={(e) => onChange('zelleEmail', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="Zelle email"
                        type="email"
                    />
                </div>

                <div className="advertiserRegisterItemhalfleft">
                    <span className="advertiserRegisterItemTitle">Revenue share %</span>
                    <input
                        required
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        value={hostData.revenueSharePercent}
                        onChange={(e) => onChange('revenueSharePercent', e.target.value)}
                        className="advertiserRegisterItemInput"
                        placeholder="10"
                    />
                </div>

                <input
                    type="submit"
                    className="advertiserRegisterSubmitBtn"
                    value={submitting ? 'Creating…' : 'Create Screen Host'}
                    disabled={submitting}
                />
            </form>
        </div>
    );
}
